import { render, staticRenderFns } from "./bridge_user.vue?vue&type=template&id=24f96fdc&"
import script from "./bridge_user.vue?vue&type=script&lang=js&"
export * from "./bridge_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports